<template>
  <div
    class="post-theme-container"
    :class="postType"
  >
    <PostTop
      :post="post"
      :is-post-with-image="isPostWithImage"
    />
    <PostMiddle
      :post="post"
      :is-post-with-image="isPostWithImage"
    />
    <PostBottomThemeAndSentiment
      :post="post"
      :is-post-with-image="isPostWithImage"
    />
  </div>
</template>

<script>
import PostTop from '@/components/Post/PostTop';
import PostMiddle from '@/components/Post/PostMiddle';
import PostBottomThemeAndSentiment from '@/components/Post/PostBottomThemeAndSentiment';

export default {
  name: 'PostThemeAndSentiment',
  components: {
    PostTop,
    PostMiddle,
    PostBottomThemeAndSentiment,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isPostWithImage() {
      return Boolean(this.post.image_url);
    },
    postType() {
      return (this.isPostWithImage) ? 'post-type--image' : 'post-type--regular';
    },
  },
};
</script>

<style scoped lang="scss">
  .post-theme-container {
    display: inline-grid;
    grid-template-columns: 1fr;
    vertical-align: top;
  }

  .post-type--regular {
    grid-template-rows: 205px auto 128px;
    width: 100%;
  }

  .post-type--image {
    grid-template-rows: 275px auto 128px;
    width: 100%;
  }

  @media screen and (max-width: 600px) {
    .post-theme-container {
      width: 200px;
    }
  }
</style>
